import type { RouteObject } from 'react-router';
import portalRoutes from '@@/products/portal/portal.routes';
import adminRoutes from '@@/products/admin/admin.routes';
import React, { lazy } from 'react';

import CxCentralWrapper from './layouts/CxCentralWrapper';
import GlobalAuthProvider from '@@/contexts/GlobalAuthProvider';
import casesRoutes from '@@/products/cases/Routes';
const CxCentralHomePage = lazy(() => import('./pages/HomePage/HomePage'));

const cxCentralRoutes: RouteObject[] = [
  {
    element: <GlobalAuthProvider />,
    children: [
      {
        element: <CxCentralWrapper />,
        children: [
          {
            index: true,
            element: <CxCentralHomePage />
          }
        ]
      }
    ]
  }
];

const globalRoutes: RouteObject[] = [
  {
    path: '/',
    children: [
      ...cxCentralRoutes,
      ...portalRoutes,
      ...adminRoutes,
      ...casesRoutes
      /*{
        path: '*',
        element: <Error404Page />
      }*/
    ]
  }
];

export default globalRoutes;
